import { AuthTabEnum } from '~/enums'

export const useAuthStore = defineStore('authStore', {
  state: () => ({
    enablePreEscape: false,
    warningEscapsed: false,
    forgotPasswordStepSendMail: false,
    forgotPasswordStepReset: false,
    enableWelcomeModal: false,
    selectedAuthTab: AuthTabEnum.Login,
    isSidebarOpen: false,
  }),
  actions: {
    setPreEscape(value: boolean) {
      this.enablePreEscape = value
    },
    setWarningEscaped(value: boolean) {
      this.warningEscapsed = value
    },
    setForgotPasswordStepSendMail(value: boolean) {
      this.forgotPasswordStepSendMail = value
    },
    setForgotPasswordStepReset(value: boolean) {
      this.forgotPasswordStepReset = value
    },
    setEnableWelcomeModal(value: boolean) {
      this.enableWelcomeModal = value
    },
    setSelectedAuthTab(value: AuthTabEnum) {
      this.selectedAuthTab = value
    },
    setIsSidebarOpen(value: boolean) {
      this.isSidebarOpen = value
    },
  },
})
